export const SELECT_VINTAGE = "SELECT_VINTAGE";
export const RESET_VINTAGE = "RESET_VINTAGE";
